import { SnackbarNotification } from '@/config/types';

import { setNotificationsStateById } from '../NotificationsContext';

export const setSnackbarNotification =
  (setStateById: setNotificationsStateById) => (snackbarNotification: SnackbarNotification) => {
    setStateById('UPDATE_SNACKBAR_NOTIFICATION', (s) => ({
      ...s,
      snackbarNotification,
    }));
  };
